import { useEffect } from 'react'
import { setTrackedUserData } from '@BUP/services/tracker'
import { setMonitoredContext } from '@BUP/services/monitor'

export const useEnrollmentTracking = (enrollment, role) => {
  useEffect(() => {
    if (enrollment) {
      setTrackedUserData({ enrollmentId: enrollment.id })
      setMonitoredContext('enrollment', {
        enrollmentId: enrollment.id,
        organizationId: enrollment.organizationId,
        userId: enrollment.userId,
        roleId: enrollment.roleId
      })
    }
  }, [enrollment?.id, enrollment?.organizationId, enrollment?.userId, enrollment?.roleId])

  useEffect(() => {
    if (role) {
      setMonitoredContext('role', {
        roleId: role.id,
        roleType: role.type
      })
    }
  }, [role?.id, role?.type])
}
